import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { metricColor } from "../helperFunctions/edgeMetricColor";

// Label + unit per edge metric shown in the result view.
const METRIC_INFO = {
  diameter: { label: "Diameter", unit: "m" },
  first_year_pipe_flow: { label: "Flow (first year)", unit: "l/s" },
  final_year_pipe_flow: { label: "Flow (final year)", unit: "l/s" },
};

// Legend for the result-view edge coloring: a green→red gradient bar with the
// min/max of the currently selected metric.
export const MetricLegend = ({ range, metric }) => {
  const { t } = useTranslation();
  if (!range || range.min == null) return null;
  const { min, max } = range;
  const info = METRIC_INFO[metric] || METRIC_INFO.diameter;

  const stops = [0, 0.25, 0.5, 0.75, 1].map((f) =>
    metricColor(min + f * (max - min), range, metric)
  );
  const gradient = `linear-gradient(to top, ${stops.join(", ")})`;
  const fmt = (v) =>
    `${Number(v).toLocaleString(undefined, { maximumFractionDigits: 2 })} ${info.unit}`;

  return (
    <Box
      className="absolute right-4 bottom-20 flex items-stretch gap-2 p-2 rounded"
      sx={{
        zIndex: 9999,
        backgroundColor: "rgba(255,255,255,0.9)",
        boxShadow: 2,
      }}
    >
      <Box className="flex flex-col justify-between items-end h-32">
        <Typography variant="caption">{fmt(max)}</Typography>
        <Typography variant="caption" sx={{ fontWeight: 600 }}>
          {t(info.label)}
        </Typography>
        <Typography variant="caption">{fmt(min)}</Typography>
      </Box>
      <Box
        sx={{
          width: 14,
          borderRadius: "3px",
          background: gradient,
          border: "1px solid rgba(0,0,0,0.2)",
        }}
      />
    </Box>
  );
};
